// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    markets_market_summary: 'Leyendo cómo está el mercado',
    markets_find_indicators: 'Buscando entre los indicadores',
    markets_indicator_detail: 'Leyendo el indicador',
    markets_find_reports: 'Buscando entre los informes del sector',
    markets_exposure_to: 'Calculando a qué estamos expuestos',
    markets_open_impacts: 'Mirando los riesgos y oportunidades abiertos',
    markets_simulate_change: 'Simulando el cambio de precio',
    markets_supplier_vs_market: 'Comparando los proveedores con el mercado',
    markets_record_decision: 'Registrando la decisión',
  },
  ca: {
    markets_market_summary: 'Llegint com està el mercat',
    markets_find_indicators: 'Cercant entre els indicadors',
    markets_indicator_detail: 'Llegint l’indicador',
    markets_find_reports: 'Cercant entre els informes del sector',
    markets_exposure_to: 'Calculant a què estem exposats',
    markets_open_impacts: 'Mirant els riscos i oportunitats oberts',
    markets_simulate_change: 'Simulant el canvi de preu',
    markets_supplier_vs_market: 'Comparant els proveïdors amb el mercat',
    markets_record_decision: 'Registrant la decisió',
  },
  en: {
    markets_market_summary: 'Reading the state of the market',
    markets_find_indicators: 'Looking through the indicators',
    markets_indicator_detail: 'Reading the indicator',
    markets_find_reports: 'Looking through the sector reports',
    markets_exposure_to: 'Working out what we are exposed to',
    markets_open_impacts: 'Looking at the open risks and opportunities',
    markets_simulate_change: 'Simulating the price change',
    markets_supplier_vs_market: 'Comparing the suppliers with the market',
    markets_record_decision: 'Recording the decision',
  },
  fr: {
    markets_market_summary: 'Lecture de l’état du marché',
    markets_find_indicators: 'Recherche parmi les indicateurs',
    markets_indicator_detail: 'Lecture de l’indicateur',
    markets_find_reports: 'Recherche parmi les rapports sectoriels',
    markets_exposure_to: 'Calcul de notre exposition',
    markets_open_impacts: 'Consultation des risques et opportunités ouverts',
    markets_simulate_change: 'Simulation de la variation de prix',
    markets_supplier_vs_market: 'Comparaison des fournisseurs avec le marché',
    markets_record_decision: 'Enregistrement de la décision',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
